import ReducerUtils         from "../../../utils/ReducerUtils"
import Actions              from "../../../model/constant/actions"

const deletingAdGroup = ReducerUtils.createReducer(false,{
  [Actions.DELETING_ADGROUP] : (state,action) => action.status
})

export default deletingAdGroup
